import clsx from 'clsx';
import type { ReactNode } from 'react';
import { PoweredByChukua } from '../../shared/features/organization/components/PoweredByChukua';
import { ColorModeToggle } from '../../shared/features/theme/components/ColorModeToggle';
import { SidebarUser } from './SidebarUser';

interface SidebarFooterProps {
  collapsed: boolean;
  /** Extra control above the theme toggle, e.g. the rail's expand button. */
  children?: ReactNode;
}

/** Theme, signed-in user and the Chukua credit — shared by the desktop rail and the phone drawer. */
export function SidebarFooter({ collapsed, children }: SidebarFooterProps) {
  return (
    <div className={clsx('flex flex-col gap-2 border-t border-line p-2.5', collapsed && 'items-center')}>
      {children}
      <div className={clsx(!collapsed && 'px-1.5')}>
        <ColorModeToggle compact={collapsed} />
      </div>
      <SidebarUser collapsed={collapsed} />
      {!collapsed && (
        <div className="px-1.5 pt-1">
          <PoweredByChukua />
        </div>
      )}
    </div>
  );
}
